module.exports = __webpack_public_path__ + "media/images/badminton-image-289b4d12a2f57b86bf69667787be9d23.jpg";